import { MmRoutesEnum } from "./mm-routes.enum";
import { MMRoutingModule } from "./mm-routing.module";

export const routeToPath = new Map<MmRoutesEnum, string>([
  [MmRoutesEnum.projects, `/${MmRoutesEnum.projects}`],
  [MmRoutesEnum.access_denied, `/${MmRoutesEnum.access_denied}`],
  [MmRoutesEnum.faults, `/projects/${MmRoutesEnum.faults}`],
  [MmRoutesEnum.user_variables, `/projects/${MmRoutesEnum.user_variables}`],
  [MmRoutesEnum.project_companies, `/projects/${MmRoutesEnum.project_companies}`],
  [MmRoutesEnum.project_crafts, `/projects/${MmRoutesEnum.project_crafts}`],
  [MmRoutesEnum.project_variables, `/projects/${MmRoutesEnum.project_variables}`],
  [MmRoutesEnum.project_type1, `/projects/${MmRoutesEnum.project_type1}`],
  [MmRoutesEnum.project_type2, `/projects/${MmRoutesEnum.project_type2}`],
])
